function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'milky-moka': 'rgb(219, 190, 179)','milk-tea': 'rgb(219, 190, 179)','black-forest': 'rgb(72, 83, 81)','black-forest-coated': 'rgb(72, 83, 81)','apricote-brandy': 'rgb(247, 164, 154)','apricot-brandy': 'rgb(247, 164, 154)','apricot-brandy-coated': 'rgb(247, 164, 154)','cherry-blossom': 'rgb(241, 202, 201)','blossom-pink': 'rgb(241, 202, 201)','dalia-orange': 'rgb(238, 139, 36)','miracle-red': 'rgb(219, 99, 36)','mint': 'rgb(199, 219, 204)','green-quartz': 'rgb(104, 138, 139)','green-quartz-2024': 'rgb(104, 138, 139)','pink-charlotte': 'rgb(193, 30, 115)','blue-horizon': 'rgb(44, 111, 157)','caramel': 'rgb(211, 123, 92)','lilypad': 'rgb(167, 174, 147)','lily-pad': 'rgb(167, 174, 147)','myrtle-green': 'rgb(105, 101, 82)','whisper-pink': 'rgb(236, 192, 190)','whisper-powder': 'rgb(236, 192, 190)','navy': 'rgb(38, 64, 89)','ocean-blue': 'rgb(38, 64, 89)','goji-red': 'rgb(199, 0, 0)','koala-grey': 'rgb(182, 191, 195)','polar-night-black': 'rgb(0, 0, 0)','black-coated': 'rgb(0, 0, 0)','digital-lavender': 'rgb(230, 230, 250)','french-oak': 'rgb(177, 166, 151)','golden-leaf': 'rgb(224, 164, 88)','star-dust': 'rgb(8, 0, 43)','pacific-blue': 'rgb(0, 0, 255)','gingko-yellow': 'rgb(255, 215, 0)','galaxy-blue': 'rgb(79, 141, 201)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
